// Los permisos efectivos llegan del servidor, incluyendo el estado global del
// módulo. El rol no concede accesos locales ni sirve como valor por defecto.
// Una pantalla que reúne varios módulos (Configuraciones) recibe la lista y se abre
// con que el usuario tenga uno de ellos.
export const hasModulePermission = (user, moduleKey) => {
  if (Array.isArray(moduleKey)) {
    return moduleKey.some((key) => hasModulePermission(user, key));
  }
  return Boolean(moduleKey && Array.isArray(user?.moduleKeys) && user.moduleKeys.includes(moduleKey));
};

// Mismos nombres de rol que acepta el backend (userModulePermissionsService).
const SUPER_ADMIN_ROLES = ["super administrador", "superadministrador", "superadmin"];

export const isSuperAdmin = (user) =>
  SUPER_ADMIN_ROLES.includes(String(user?.USU_CROL || user?.rol || "").trim().toLowerCase());

// El rol nunca da acceso por sí solo, pero sí puede quitarlo: una ruta `superAdminOnly`
// pide además del módulo ser Super Administrador.
export const canAccessRoute = (user, route) =>
  Boolean(
    user &&
    route?.layout === "/admin" &&
    hasModulePermission(user, route.moduleKey) &&
    (!route.superAdminOnly || isSuperAdmin(user))
  );

export const getFirstAccessiblePath = (user, routes = []) => {
  const route = routes.find((item) => item.show && canAccessRoute(user, item));
  return route ? `${route.layout}${route.path}` : null;
};
